import React, { useEffect } from 'react'
import PricingPlans from '../components/PricingPlans'
import PrivateLayout from '../templates/PrivateLayout'

export default function Plans() {

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Planos | Fonoaudiologia na Prática";

    return () => {
      document.title = previousTitle;
    };
  }, []);


  return (
    <PrivateLayout>
      <PricingPlans />
    </PrivateLayout>
  )
}
